export function getDropdownOptions(value) {
  if (!Array.isArray(value) || !value?.length) return []

  return value.map(item => ({
    id: item?.id ?? item,
    text: item?.text ?? item,
  }))
}
